/** @format */

import axios from "axios";
import Carousel from "react-multi-carousel";
import { useOutletContext } from "react-router-dom";
import React, { useEffect, useState, useMemo } from "react";
import { header } from "../../../../../components/api/Header";
import LoadingCard from "../../../../../components/loading/loadingCard";
import { getEnv } from "../../../../../lib/env";

function Manbalar({ date, singlerow, region }) {
  const [data, setData] = useState([]);
  const [collapsed] = useOutletContext();
  const [loading, setLoading] = useState(false);

  const responsive = useMemo(
    () => ({
      superLargeDesktop: {
        breakpoint: { max: 1024, min: 464 },
        items: 3,
      },
      desktop: {
        breakpoint: { max: 3000, min: 800 },
        items: region === "jizz" || region === "abmk" ? 5 : 6,
      },
      tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
      },
      mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
      },
    }),
    [region]
  );

  const widthCon = useMemo(() => {
    const w = window.innerWidth;
    if (region === "qqr") {
      return collapsed
        ? { width: `calc(${w}px - 770px)` }
        : { width: `calc(${w}px - 956px)` };
    }
    if (region === "and") {
      return { width: `${w}px` };
    }
    if (region === "jizz") {
      return collapsed
        ? { width: `calc(${w}px - 770px)` }
        : { width: `calc(${w}px - 660px)` };
    }
    if (region === "abmk") {
      return collapsed
        ? { width: `calc(${w}px - 770px)` }
        : { width: `calc(${w}px - 960px)` };
    }
    return collapsed
      ? { width: `calc(${w}px - 1000px)` }
      : { width: `calc(${w}px - 880px)` };
  }, [collapsed, region]);

  useEffect(() => {
    let ignore = false;
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${getEnv('REACT_APP_BASE_URL')}/v1/region/dashboard/manbalar?date=${date}`,
          header()
        );
        if (!ignore && res?.data) setData(res.data);
      } catch (e) {
        console.log("Xato", e);
      } finally {
        if (!ignore) setLoading(false);
      }
    };

    fetchData();
    return () => {
      ignore = true;
    };
  }, [date]);

  const renderItems = () => {
    if (singlerow) {
      return data.map((d, i) => (
        <div className='statics4-box-inner text-center' key={i}>
          <h3>
            {d.suv} <span className='lower'>sm</span>
          </h3>

          <p>{d.manba_nomi}</p>
        </div>
      ));
    }
    // Pair items for double row
    const items = [];
    for (let i = 0; i < data.length; i += 2) {
      items.push(
        <div key={i} className='d-flex flex-column align-items-center'>
          <div className='statics4-box-inner text-center'>
            <h3>
              {data[i].suv} <span className='lower'>sm</span>
            </h3>
            <p>{data[i].manba_nomi}</p>
          </div>

          {data[i + 1] && (
            <div className='statics4-box-inner text-center'>
              <h3>
                {data[i + 1].suv}{" "}
                <span className='lower'>
                  m<sup>3</sup>/s
                </span>
              </h3>
              <p>{data[i + 1].manba_nomi}</p>
            </div>
          )}
        </div>
      );
    }
    return items;
  };

  if (loading) {
    return <LoadingCard loading={loading} heightSize='20vh' />;
  }

  return (
    <div className='data-content mt-3'>
      <div className='card statistic-card px-3' style={widthCon}>
        <h4 className='statics4-title'>ASOSIY MANBALAR</h4>
        {data.length > 0 && (
          <Carousel
            responsive={responsive}
            infinite
            autoPlay
            containerClass='carousel-container'
            renderArrowsWhenDisabled
            removeArrowOnDeviceType='desktop'
            autoPlaySpeed={10000}>
            {renderItems()}
          </Carousel>
        )}
      </div>
    </div>
  );
}

export default Manbalar;
